// компонент, который показывает ограниченный набор значений 10 УС, которые доступны в указанном офисе
import { useState, useEffect, ComponentProps } from 'react';
import { inject, observer } from 'mobx-react';
import { SelectInput, MultiSelectInput } from '../forms';
import { partnerOfficeActions, PartnerOfficeStore } from '../../../partners/store/offices/partnerOfficeStore';

type Ref10ForOfficeSelectorProps = Omit<ComponentProps<typeof SelectInput | typeof MultiSelectInput>, 'value' | 'defaultValue'> & {
    partnerOfficeStore?: PartnerOfficeStore,
    officeId: string,
    serviceId: number,
    multiSelect?: boolean,
    excludedValues?: Array<number>,
    addId?: number,
    addName?: string,
  };

const Ref10ForOfficeSelector = (props: Ref10ForOfficeSelectorProps) => {
  const {
    partnerOfficeStore,
    officeId,
    multiSelect,
    excludedValues,
    serviceId,
    addName,
    addId,
    name,
    label,
    disabled, 
    placeholder,
    isNextField,
    ...rest
  } = props;

  const { refValuesForOffice10, refValuesForOfficeRequest10 } = partnerOfficeStore;

  const toAdd = addId ? [{ id: addId, name: addName, refId: 10 }] : [];
  const filteredValues = [...refValuesForOffice10, ...toAdd].filter((v) => (!(excludedValues ?? []).includes(v.id)));

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    if (officeId && serviceId) {
      if (
        (((refValuesForOfficeRequest10?.partnerOfficeId ?? '') !== officeId)
        || ((refValuesForOfficeRequest10?.serviceId ?? 0) !== serviceId))
         && (!loading)) {
        setLoading(true);
        await partnerOfficeActions.getRefValuesForOffice(
          {
            partnerOfficeId: officeId,
            serviceId,
            refId: 10,
          }
        ).finally(() => setLoading(false));
      }
    } else {
      partnerOfficeActions.clearOfficesServicesForSelector();
    }
  };

  useEffect(() => {
    loadData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [officeId, serviceId]);

  return (
    multiSelect
      ? (
        <MultiSelectInput
          { ...rest }
          isMulti
          noOptionsMessage={ () => { return 'Нет вариантов'; } }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          sort
          name={ name }
          label={ label }
          disabled={ disabled }
          placeholder={ placeholder }
          isNextField = { isNextField }
        />
      )
      : (
        <SelectInput
          { ...rest }
          data={ filteredValues }
          dataTitle='name'
          dataValue='id'
          loading={ loading }
          sort
          name={ name }
          label={ label }
          disabled={ disabled }
          placeholder = { placeholder }
          isNextField = { isNextField }
        />
      )

  );
};

export default inject('partnerOfficeStore')(observer(Ref10ForOfficeSelector));
